//import axios from "axios";
import  moment from "moment";

export default class DymoPrintHelper {

  constructor(vueJs, printer) {
    this.vueJs = vueJs;
    this.printer = printer;
    this.dymoPrinter = null;
  }

  isIOS() {
    //var userAgent = window.navigator.userAgent.toLowerCase(),
    //safari = /safari/.test( userAgent ),
    //ios = /iphone|ipod|ipad/.test( userAgent );
    //console.log("window.IS_IOS_APP: " + window.IS_IOS_APP);
    return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.dymoPrinter;
    //return window.IS_IOS_APP == true; //window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.dymoPrinter;
  }

  /*
  * Finds any local Dymo printers
  */
  async init() {
    let me = this;
    if (!me.isIOS()) { // if not running inside the iPad app
        window.__PRINTER__NETWORK__ADDRESS__ = me.printer.networkAddress;
        if (me.printer.networkAddress === "localhost") { // IF an address such as "localhost" has been provided
            this.vueJs.$dymo.label.framework.trace = 1; //true
            return new Promise(resolve => {
              this.vueJs.$dymo.label.framework.init(async () => {
                const environment = this.vueJs.$dymo.label.framework.checkEnvironment();
                if (environment.errorDetails) {
                  console.error(environment.errorDetails);
                  resolve(null)
                  return;
                }

                const printers = await this.vueJs.$dymo.label.framework.getPrintersAsync().then(printers => printers);
                if (!printers || printers.length === 0) {
                  console.log("Printer not found");
                  resolve(null)
                  return;
                }
                me.dymoPrinter = printers[0];
                resolve(me.dymoPrinter);
            });
          });
        }
      }

      return Promise.resolve(null);
  }
  

  printViaIOSApp(renderLabelReq, printer, resolve) {
    var appMsg = {
            "action": "print",
            "printer": {
              //"amihere" : "Hello",
              "address": printer.networkAddress ? printer.networkAddress : printer.address,
              "template": printer.printerType.labelDefinition
            },
            "data": renderLabelReq
            //"image": pgmBlob,            
    };

    //alert ( JSON.stringify(appMsg) );

    var isInIos =window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.dymoPrinter;

    if (isInIos) {
        console.log('Sending to the iPad app')
        

        

        window.webkit.messageHandlers.dymoPrinter.postMessage(
          appMsg);
        
      }

      resolve(null);

      /*
      axios( {
          method: "POST",
          url: "https://7eib6j0qgj.execute-api.ap-southeast-2.amazonaws.com/dev/renderlabel",
          responseType: 'blob', // important
          data: renderLabelReq
        })
          .then(async function (response) {
              console.log('We have a label now ....', response.data);
              
              // response is a Blob
              var pgmBlob = await (new Promise((resolveBlob, reject) => {
                let reader = new FileReader();
                reader.addEventListener('load', () => {
                  // reader.result holds a data URL representation of response

                  //"data:image/x-portable-graymap;base64,

                  var blob = reader.result.substring(reader.result.indexOf(",")+1);

                  resolveBlob(blob);
                }, false);
                reader.addEventListener('error', () => {
                  reject(reader.error);
                }, false);

                reader.readAsDataURL(response.data);
              }));

              console.log('We have a label pgmBlobpgmBlob ....', pgmBlob);

              // Send it to the iPAD app
              if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.dymoPrinter) {
                console.log('Sending to the iPad app')
                window.webkit.messageHandlers.dymoPrinter.postMessage(
                  {
                    "action": "print",
                    "printer": {
                      "type": "brother",
                      "address": printer.networkAddress
                    }
                    //"image": pgmBlob,
                    
                  });
              }
              resolve(null);
          }
        );
        */
  }
  /*
  *
  */
  print(data) {
    console.log("print called", data, this.printer);
    let me = this;   

    let visitCopy = JSON.parse(JSON.stringify(data.visit));
    visitCopy.location = data.location;


    let labelFields = {};
    labelFields["Visitor_FullName"] = (data.visit.visitor || {}).name || 'N/a';
    labelFields["Location_Name"] = (data.location || {}).name || 'N/a'
    labelFields["Host_FullName"] = (data.visit.host || {}).name || 'N/a';
    labelFields["Visit_CheckInTime"] = moment().format('DD/MM/YYYY HH:mm');
    labelFields["Visit_Checkout_Code"] = (data.visit.checkout || { code: "" } ).code.toUpperCase();

    let renderLabelReq = 
      {
        "visit": visitCopy,
        "fields" : labelFields,
        //"labelXml": me.printer.printerType.labelDefinition
    };

    return new Promise(resolve => {
      var printerTheLabel = function () {
          var inIOS = me.isIOS();
          if (inIOS) { // Running inside iPad app
              me.printViaIOSApp(renderLabelReq, me.printer, resolve);
          }
          else {
            if (me.dymoPrinter && me.printer && me.printer.printerType && me.printer.printerType.labelDefinition && me.printer.networkAddress === "localhost") {
                var $dymo = this.vueJs.$dymo;
                window.__PRINTER__NETWORK__ADDRESS__ = "localhost";
                const label = $dymo.label.framework.openLabelXml(me.printer.printerType.labelDefinition);
                if (label) {
                    var objectNames = label.getObjectNames();
                    if (objectNames.indexOf("Visitor_FullName") > -1) label.setObjectText('Visitor_FullName', (data.visit.visitor || {}).name || 'N/a');
                    if (objectNames.indexOf("Location_Name") > -1) label.setObjectText('Location_Name', (data.location || {}).name || 'N/a');
                    if (objectNames.indexOf("Host_FullName") > -1) label.setObjectText('Host_FullName', (data.visit.host || {}).name || 'N/a');
                    if (objectNames.indexOf("Visit_CheckInTime") > -1) label.setObjectText('Visit_CheckInTime', moment().format('DD/MM/YYYY HH:mm'));
                    if (objectNames.indexOf("Visit_Checkout_Code") > -1) label.setObjectText('Visit_Checkout_Code', data.visit.checkout.code.toUpperCase());

                    console.log("About to call printAsync");
                      
                      label.printAsync(me.dymoPrinter.name).then(function (state) {
                        console.log("printAsync complete", state);
                        resolve(state);
                        return state;
                      });
                  }
            }
            else {
              resolve({}); // nothing to print
            }
          }
        };

        if (me.isIOS()) {
          printerTheLabel(); 
        }
        else {
          if (!me.dymoPrinter) {
            me.init().then(() => {
              printerTheLabel()
            });
          } else { printerTheLabel(); }
        }
 
      });


  }

}